(function () {
  const sections = document.querySelectorAll('[data-food-section]');
  if (!sections.length) return;

  sections.forEach((root) => {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (!entry.isIntersecting) return;
          setTimeout(() => entry.target.classList.add('on'), index * 70);
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    root.querySelectorAll('.r, .rl, .rr, .rs').forEach((el) => revealObserver.observe(el));

    root.querySelectorAll('.ing-card').forEach((card, index) => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(28px)';
      card.style.transition = 'opacity .6s ' + index * 0.07 + 's ease, transform .6s ' + index * 0.07 + 's cubic-bezier(.34,1.56,.64,1)';
      const cardObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            cardObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.1 }
      );
      cardObserver.observe(card);
    });

    const track = root.querySelector('[data-ingredient-track]');
    if (track) {
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;

      track.addEventListener('mousedown', (event) => {
        isDown = true;
        track.style.cursor = 'grabbing';
        startX = event.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });

      window.addEventListener('mouseup', () => {
        isDown = false;
        track.style.cursor = 'grab';
      });

      track.addEventListener('mousemove', (event) => {
        if (!isDown) return;
        event.preventDefault();
        const x = event.pageX - track.offsetLeft;
        track.scrollLeft = scrollLeft - (x - startX) * 1.2;
      });

      track.addEventListener('touchstart', (event) => {
        startX = event.touches[0].pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      }, { passive: true });

      track.addEventListener('touchmove', (event) => {
        const x = event.touches[0].pageX - track.offsetLeft;
        track.scrollLeft = scrollLeft - (x - startX) * 1.2;
      }, { passive: true });
    }

    root.querySelectorAll('.ct-row').forEach((row) => {
      const yes = row.querySelector('.ct-yes');
      row.addEventListener('mouseenter', () => {
        if (!yes) return;
        yes.style.transform = 'scale(1.3)';
        yes.style.transition = 'transform .2s';
      });
      row.addEventListener('mouseleave', () => {
        if (!yes) return;
        yes.style.transform = 'scale(1)';
      });
    });

    root.addEventListener('mousemove', (event) => {
      const rect = root.getBoundingClientRect();
      const nx = ((event.clientX - rect.left) / Math.max(rect.width, 1) - 0.5) * 12;
      const ny = ((event.clientY - rect.top) / Math.max(rect.height, 1) - 0.5) * 12;
      root.querySelectorAll('.fh-tag').forEach((tag, index) => {
        const factor = (index % 2 === 0 ? 1 : -1) * (index * 0.4 + 0.5);
        tag.style.transform = 'translate(' + nx * factor + 'px,' + ny * factor + 'px)';
      });
    });
  });
})();
